
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"KnowledgeSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cms_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"EX_AI_KnowledgeSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cms_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cms_id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sync_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"document_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cms_document_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"external_document_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pages_document_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"products_document_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"events_document_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"business_cards_document_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"public_addresses_document_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manual_document_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_synced_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"system_prompt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"system_prompt_overrides_base"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"indexable_types"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enabled_tools"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":558}};
    doc.loc.source = {"body":"query KnowledgeSource($cms_id: Int!) {\n    EX_AI_KnowledgeSource(cms_id: $cms_id) {\n        id\n        name\n        type\n        sync_status\n        document_count\n        cms_document_count\n        external_document_count\n        pages_document_count\n        products_document_count\n        events_document_count\n        business_cards_document_count\n        public_addresses_document_count\n        manual_document_count\n        last_synced_at\n        system_prompt\n        system_prompt_overrides_base\n        indexable_types\n        enabled_tools\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["KnowledgeSource"] = oneQuery(doc, "KnowledgeSource");
        
